import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return null;
  }

  const getRoleDashboard = () => {
    switch (user.role) {
      case 'admin':
        return getAdminDashboard();
      case 'logistika':
        return getLogistikaDashboard();
      case 'magacin':
        return getMagacinDashboard();
      case 'lager':
        return getLagerDashboard();
      case 'odrzavanje':
        return getOdrzavanjeDashboard();
      case 'attendance_manager':
        return getAttendanceDashboard();
      case 'finansije':
        return getFinansijeDashboard();
      case 'finansijski_gotovi':
        return getFinansijskiGotoviDashboard();
      case 'direktor':
        return getDirektorDashboard();
      default:
        return getVisitorDashboard();
    }
  };

  const getAdminDashboard = () => (
    <>
      <DashboardCard
        icon="pi pi-th-large"
        title="Upravljanje projektima"
        subtitle="Opis projekta"
        onClick={() => navigate('/projects')}
      />
      <DashboardCard
        icon="pi pi-shopping-cart"
        title="Zahtev za nabavku"
        subtitle="Kreiraj zahtev"
        onClick={() => navigate('/procurement/create')}
      />
      <DashboardCard
        icon="pi pi-chart-line"
        title="Potrošnja"
        subtitle="Potrošnja"
        onClick={() => navigate('/consumption')}
      />
      <DashboardCard
        icon="pi pi-box"
        title="Materijali"
        subtitle="Materijali"
        onClick={() => navigate('/materials')}
      />
      <DashboardCard
        icon="pi pi-users"
        title="Korisnici"
        subtitle="Upravljanje korisnicima"
        onClick={() => navigate('/users')}
      />
      <DashboardCard
        icon="pi pi-file-export"
        title="Izveštaji"
        subtitle="Pregled izveštaja"
        onClick={() => navigate('/admin/activity-logs')}
      />
    </>
  );

  const getLogistikaDashboard = () => (
    <>
      <DashboardCard
        icon="pi pi-list"
        title="Potrošnja"
        subtitle="Pregled potrošnje"
        onClick={() => navigate('/consumption')}
      />
      <DashboardCard
        icon="pi pi-box"
        title="Materijali"
        subtitle="Upravljanje materijalima"
        onClick={() => navigate('/materials')}
      />
      <DashboardCard
        icon="pi pi-file"
        title="Prijemnice"
        subtitle="Pregled prijemnica"
        onClick={() => navigate('/receipts')}
      />
      <DashboardCard
        icon="pi pi-trash"
        title="Rashodovanje"
        subtitle="Pregled rashodovanja"
        onClick={() => navigate('/disposals')}
      />
      <DashboardCard
        icon="pi pi-shopping-cart"
        title="Zahtev za nabavku"
        subtitle="Kreiraj zahtev"
        onClick={() => navigate('/procurement/create')}
      />
      <DashboardCard
        icon="pi pi-file-export"
        title="Izveštaji"
        subtitle="Logistika izveštaji"
        onClick={() => navigate('/logistics/reports')}
      />
    </>
  );

  const getMagacinDashboard = () => (
    <>
      <DashboardCard
        icon="pi pi-list"
        title="Lista proizvoda"
        subtitle="Pregled proizvoda"
        onClick={() => navigate('/magacin/products')}
      />
      <DashboardCard
        icon="pi pi-plus"
        title="Dodaj proizvod"
        subtitle="Novi proizvod"
        onClick={() => navigate('/magacin/products/create')}
      />
      <DashboardCard
        icon="pi pi-minus"
        title="Skini sa stanja"
        subtitle="Ukloni proizvod"
        onClick={() => navigate('/magacin/removals')}
      />
      <DashboardCard
        icon="pi pi-users"
        title="Ko duži"
        subtitle="Pregled pozajmica"
        onClick={() => navigate('/magacin/loans')}
      />
      <DashboardCard
        icon="pi pi-history"
        title="Istorija dolazaka"
        subtitle="Pregled dolazaka"
        onClick={() => navigate('/magacin/arrivals')}
      />
      <DashboardCard
        icon="pi pi-shopping-cart"
        title="Zahtev za nabavku"
        subtitle="Kreiraj zahtev"
        onClick={() => navigate('/procurement/create')}
      />
    </>
  );

  const getLagerDashboard = () => (
    <>
      <DashboardCard
        icon="pi pi-tag"
        title="Gotovi proizvodi"
        subtitle="Pregled proizvoda"
        onClick={() => navigate('/lager/finished-products')}
      />
      <DashboardCard
        icon="pi pi-cog"
        title="Proizvodnja"
        subtitle="Dnevna proizvodnja"
        onClick={() => navigate('/lager/production')}
      />
      <DashboardCard
        icon="pi pi-truck"
        title="Transport"
        subtitle="Transport proizvoda"
        onClick={() => navigate('/lager/transport')}
      />
      <DashboardCard
        icon="pi pi-chart-bar"
        title="Trenutno Stanje"
        subtitle="Stanje lagera"
        onClick={() => navigate('/lager/current-status')}
      />
      <DashboardCard
        icon="pi pi-shopping-cart"
        title="Zahtev za nabavku"
        subtitle="Kreiraj zahtev"
        onClick={() => navigate('/procurement/create')}
      />
      <DashboardCard
        icon="pi pi-cog"
        title="Hilti Proizvodnja"
        subtitle="Hilti proizvodnja"
        onClick={() => navigate('/hilti/production')}
      />
      <DashboardCard
        icon="pi pi-box"
        title="Hilti Materijali"
        subtitle="Hilti materijali"
        onClick={() => navigate('/hilti/materials')}
      />
    </>
  );

  const getOdrzavanjeDashboard = () => (
    <>
      <DashboardCard
        icon="pi pi-shopping-cart"
        title="Zahtev za nabavku"
        subtitle="Kreiraj zahtev"
        onClick={() => navigate('/procurement/create')}
      />
      <DashboardCard
        icon="pi pi-list"
        title="Moji zahtevi"
        subtitle="Pregled podnetih zahteva"
        onClick={() => navigate('/procurement')}
      />
    </>
  );

  const getAttendanceDashboard = () => (
    <>
      <DashboardCard
        icon="pi pi-user"
        title="Radnici"
        subtitle="Pregled radnika"
        onClick={() => navigate('/workers')}
      />
      <DashboardCard
        icon="pi pi-calendar-check"
        title="Dnevna evidencija"
        subtitle="Evidencija prisustva"
        onClick={() => navigate('/attendance')}
      />
      <DashboardCard
        icon="pi pi-clock"
        title="Individualna odsustva"
        subtitle="Pregled odsustava"
        onClick={() => navigate('/absence')}
      />
      <DashboardCard
        icon="pi pi-chart-line"
        title="Mesečni izveštaji"
        subtitle="Izveštaji prisustva"
        onClick={() => navigate('/attendance/reports')}
      />
      <DashboardCard
        icon="pi pi-shopping-cart"
        title="Zahtev za nabavku"
        subtitle="Kreiraj zahtev"
        onClick={() => navigate('/procurement/create')}
      />
    </>
  );

  const getFinansijeDashboard = () => (
    <>
      <DashboardCard
        icon="pi pi-file"
        title="Knjige"
        subtitle="Finansijske knjige"
        onClick={() => navigate('/finance/books')}
      />
      <DashboardCard
        icon="pi pi-building"
        title="Firme"
        subtitle="Pregled firmi"
        onClick={() => navigate('/finance/companies')}
      />
      <DashboardCard
        icon="pi pi-shopping-cart"
        title="Zahtev za nabavku"
        subtitle="Kreiraj zahtev"
        onClick={() => navigate('/procurement/create')}
      />
    </>
  );

  const getFinansijskiGotoviDashboard = () => (
    <>
      <DashboardCard
        icon="pi pi-tag"
        title="Proizvodi"
        subtitle="Finansijski proizvodi"
        onClick={() => navigate('/financial/finished-products')}
      />
      <DashboardCard
        icon="pi pi-list"
        title="Finansijska lista proizvoda"
        subtitle="Lista proizvoda"
        onClick={() => navigate('/financial/production-list')}
      />
      <DashboardCard
        icon="pi pi-shopping-cart"
        title="Zahtev za nabavku"
        subtitle="Kreiraj zahtev"
        onClick={() => navigate('/procurement/create')}
      />
    </>
  );

  const getDirektorDashboard = () => (
    <>
      <DashboardCard
        icon="pi pi-chart-bar"
        title="Pregled sistema"
        subtitle="Svi moduli"
        onClick={() => navigate('/dashboard')}
      />
      <DashboardCard
        icon="pi pi-file-export"
        title="Izveštaji"
        subtitle="Svi izveštaji"
        onClick={() => navigate('/reports')}
      />
    </>
  );

  const getVisitorDashboard = () => (
    <>
      <DashboardCard
        icon="pi pi-info-circle"
        title="Dobrodošli"
        subtitle="Ograničen pristup"
        onClick={() => {}}
      />
    </>
  );

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="welcome-section">
          <i className="pi pi-home welcome-icon"></i>
          <div>
            <h1 className="welcome-title">Dobrodošli, {user.firstName} {user.lastName}</h1>
            <p className="welcome-subtitle">{user.role === 'admin' ? 'Administrator' : user.role}</p>
            <p className="welcome-system">THWL ERP SYSTEM</p>
          </div>
        </div>
      </div>
      <div className="dashboard-cards">
        {getRoleDashboard()}
      </div>
    </div>
  );
};

interface DashboardCardProps {
  icon: string;
  title: string;
  subtitle: string;
  onClick: () => void;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ icon, title, subtitle, onClick }) => {
  return (
    <Card className="dashboard-card">
      <div className="dashboard-card-content" onClick={onClick}>
        <div className="dashboard-card-icon">
          <i className={icon}></i>
        </div>
        <div className="dashboard-card-info">
          <h3 className="dashboard-card-title">{title}</h3>
          <p className="dashboard-card-subtitle">{subtitle}</p>
        </div>
        <Button
          icon="pi pi-arrow-right"
          className="dashboard-card-button"
          rounded
          text
        />
      </div>
    </Card>
  );
};

export default Dashboard;
